// extracted by mini-css-extract-plugin
module.exports = {"form-item":"form-item___3qJhA","ant-form-item-explain-error":"ant-form-item-explain-error___3TzJJ","form-footer":"form-footer___33lTf"};